<template>
  <v-container class="processos-protocolo">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Protocolo"
        sub="Cadastro de processos"
        home='/protocolo'
      />
      <div>
        <formulario />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Formulario from '../protocolo/index.vue'
// import Stat from './Stat'
// import axios from 'axios'
// import { baseApiUrl } from '../../global'
export default {
  name: 'ProcessosProtocolo',
  components: { PageTitle, Formulario },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
